import React from "react"
import cx from "classnames"

import "./scrollPanel.scss"

interface IScrollPanel {
  className?: string
}

const ScrollPanel: React.FunctionComponent<IScrollPanel> = (props) => {
  return (
    <div className={cx("scroll-panel-wrapper", props.className)}>
      <div className="main_content">{props.children}</div>
    </div>
  )
}

export default ScrollPanel
